import Vue from 'vue'
import Router from 'vue-router'

 
import Services from './pages/ServicesPage.vue'
import About from './pages/AboutPage.vue'
import Products from './pages/ProductsPages.vue'
import Clients from './pages/ClientsPages.vue'
import Contact from './pages/ContactPage.vue'
import IndexPage from './layouts/IndexPage.vue'
// 1. Import the new component we are about to create
import ServiceDetail from './pages/ServiceDetail.vue'

Vue.use(Router)

export default new Router({
    mode: 'history', // clean URLs without # hash
    routes: [
        {path: '/',  name: "IndexPage", component: IndexPage },
        {path: '/services', name: 'Services', component: Services },
        // 2. Add this dynamic route
        {path: '/services/:id', name: 'ServiceDetail', component: ServiceDetail },
        {path: '/about', name: 'About', component: About },
        {path: '/products', name: 'Products', component: Products },
        {path: '/clients', name: 'Clients', component: Clients },
        {path: '/contact', name: 'Contact', component: Contact },
    ]
})
